<template>
  <nav class="menu-desktop" @mouseleave="onFocusOut">
    <div ref="mainMenu" class="nav-menu">
      <a
        v-for="(item, i) in getItems"
        :key="i"
        :href="item.href"
        class="nav-item"
        :class="{
          'nav-item_active': item === menu.focusInfo,
          'nav-item_red': item.sectionID == 70,
        }"
        @mouseover="onFocusIn(item)"
        @click="handlerClick"
      >
        <span class="nav-item__underline">
          {{ item.name }}
        </span>
      </a>
    </div>
    <transition name="fade">
      <SubMenuDesktop
        v-if="menu.focusInfo.items && menu.focusInfo.items.length > 0 && menu.focusInfo.sectionID"
        :style="getTopMenuPosition()"
        :result="menu.focusInfo"
      />
      <SubMenuCollection
        v-else-if="menu.focusInfo.items && menu.focusInfo.items.length > 0"
        :style="getTopMenuPosition()"
        :result="menu.focusInfo"
      />
    </transition>
  </nav>
</template>

<script lang="ts" setup>
import SubMenuDesktop from '@components/Menu/MenuDesktop/SubMenuDesktop.vue';
import SubMenuCollection from '@components/Menu/MenuDesktop/SubMenuCollection.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { computed, reactive, ref } from 'vue';
import useLoader from '@use/useLoader/useLoader';

const resultsStore = useResultsStore();
const loader = useLoader();

const menu = reactive({
  focusInfo: {},
  focusImage: {},
});
const mainMenu = ref(null);

const items = computed(() => resultsStore.menus.mainMenu.items);
const getItems = computed(() => items.value.filter((el) => el.elementCnt > 0));

const onFocusIn = (item) => {
  menu.focusInfo = item;
  menu.focusImage = item.image;
};

const onFocusOut = () => {
  menu.focusInfo = {};
};

const handlerClick = (e) => {
  if (e.ctrlKey || e.metaKey) return;
  loader.start();
};

const getTopMenuPosition = () => ({
  top: `${mainMenu.value.offsetTop + mainMenu.value.offsetHeight}px`,
});
</script>

<style lang="scss" scoped>
.menu-desktop {
  //margin-bottom: 16px;
}
.nav-menu {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 125%; /* 17.5px */
  text-transform: uppercase;
  min-height: 50px;
  border-top: 1px solid #cacece;
  border-bottom: 1px solid #cacece;
}
.nav-item {
  flex-grow: 1;
  display: flex;

  &:not(:last-child):after {
    content: '';
    display: block;
    height: 20px;
    width: 1px;
    background-color: #cacece;
    margin-left: auto;
    margin-right: auto;
  }

  &_red {
    color: var(--color-red);
  }
  &_active {
    .nav-item__underline {
      &:after {
        transform: scaleX(1);
      }
    }
  }
  &__underline {
    position: relative;
    &:before {
      content: '';
      display: block;
      position: absolute;
      left: -4px;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: currentcolor;
      transition: 0.2s linear transform;
      transform: scaleX(0);
    }
    &:after {
      content: '';
      display: block;
      height: 1px;
      background-color: currentColor;
      transition: 0.2s linear transform;
      transform: scaleX(0);
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
